import { Seq } from 'immutable'
export default function stubImmutableSetSeq() {
  return Seq.Set([])
}
